import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const TicketStatusChecker = () => {
  const [bookingId, setBookingId] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const checkStatus = async () => {
    if (!bookingId.trim()) return;
    
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/ticket-verification/status/${bookingId}`);
      setStatus(response.data.status);
    } catch (error) {
      setStatus({
        error: error.response?.data?.message || 'Status check failed'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '16px',
      padding: '24px',
      boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
      border: '1px solid rgba(226, 232, 240, 0.8)'
    }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: '700',
        color: '#2d3748',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        🎫 Ticket Status Checker
      </h3>
      
      <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
        <input
          type="text"
          value={bookingId}
          onChange={(e) => setBookingId(e.target.value)}
          placeholder="Enter Booking ID (e.g., BK123456)"
          style={{
            flex: 1,
            padding: '12px',
            border: '2px solid #e2e8f0',
            borderRadius: '8px',
            fontSize: '14px'
          }}
        />
        <button
          onClick={checkStatus}
          disabled={!bookingId.trim() || loading}
          style={{
            padding: '12px 20px',
            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: bookingId.trim() && !loading ? 'pointer' : 'not-allowed',
            opacity: bookingId.trim() && !loading ? 1 : 0.6
          }}
        >
          {loading ? '⏳ Checking...' : '🔍 Check Status'}
        </button>
      </div>
      
      {status && (
        <div style={{
          padding: '16px',
          borderRadius: '12px',
          background: status.error ? 
            'linear-gradient(135deg, #fee2e2, #fecaca)' : 
            'linear-gradient(135deg, #dbeafe, #bfdbfe)',
          border: `2px solid ${status.error ? '#ef4444' : '#3b82f6'}`,
          color: status.error ? '#991b1b' : '#1e40af'
        }}>
          {status.error ? (
            <div>
              <div style={{ fontWeight: '600', marginBottom: '8px' }}>❌ Error</div>
              <div>{status.error}</div>
            </div>
          ) : (
            <div>
              <div style={{ fontWeight: '600', marginBottom: '12px' }}>
                📋 Booking: {status.bookingId}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '14px' }}>
                <div>Status: <strong>{status.status}</strong></div>
                <div>Checked In: <strong>{status.checkedIn ? '✅ Yes' : '❌ No'}</strong></div>
                <div>Checked Out: <strong>{status.checkedOut ? '✅ Yes' : '❌ No'}</strong></div>
                <div>Valid Till: <strong>{new Date(status.validTill).toLocaleDateString()}</strong></div>
                {status.entryTime && (
                  <div>Entry: <strong>{new Date(status.entryTime).toLocaleString()}</strong></div>
                )}
                {status.exitTime && (
                  <div>Exit: <strong>{new Date(status.exitTime).toLocaleString()}</strong></div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TicketStatusChecker;